import React from 'react';
import { AudioProvider } from './context/AudioContext';
import EpisodeList from './ui/EpisodeList';
import AudioPlayer from './ui/AudioPlayer';
import './App.css';

function App() {
  // Read URL parameter 'feed' or use default
  const searchParams = new URLSearchParams(window.location.search);
  const feedUrl = searchParams.get('feed') || 'https://api.riverside.fm/hosting/lyTmVj6F.rss';

  return (
    <AudioProvider>
      <div className="min-h-screen bg-brand-cream selection:bg-brand-tan/30 pb-24">
        <main className="relative z-10 pt-4">
          <EpisodeList feedUrl={feedUrl} />
        </main>
        
        <AudioPlayer />
        
        {/* Background Texture */}
        <div className="fixed inset-0 pointer-events-none opacity-[0.03] mix-blend-multiply bg-[url('https://www.transparenttextures.com/patterns/natural-paper.png')]" />
      </div>
    </AudioProvider>
  );
}

export default App;